import _ from 'lodash';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

require('bootstrap');

window.company = 'Ingenieurbau Altmark GmbH';
window.companyInitials = 'IBA',

/**
 * Sentry’s features help you identify and debug errors and give you all
 * the insight to decide when to fix or roll back. When things go to hell,
 * you’ll have help fighting fires.
 */

window.Sentry = require('@sentry/browser');

window.Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN
});

window.Sentry.configureScope(function (scope) {
    // Set tags
    scope.setTag("locale", navigator.language);

    // set context
    let data = window.__DATA__ || {};

    scope.setExtra('session', data.session);
    scope.setExtra('errors', data.errors);

    // Set user data if available.
    scope.setUser(data._user);
});

window.can = (permission) => {
    return window.__DATA__ && window.__DATA__._user && _.includes(window.__DATA__._user._can, permission);
}

window.hasRole = (rolename) => {
    if ( window.__DATA__ && window.__DATA__._user && !window.__DATA__._user._roles ) {
        window.__DATA__._user._roles = window.__DATA__._user.roles.map( (itm) => itm.name );
    }

    return window.__DATA__ && window.__DATA__._user && _.includes(window.__DATA__._user._roles, rolename);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

window.timepicker = require('jquery-clock-timepicker');
require('../../../node_modules/jquery-clock-timepicker/jquery-clock-timepicker.min.js');

window.datepicker = require('bootstrap-datepicker');
require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.de');

window.moment = require('moment');
window.selectpicker = require('bootstrap-select');
window.swal = require('sweetalert');

